<template>
  <div class="ma-4">
    <v-card>
      <v-data-table
        loading-text="Đang Tải"
        :headers="headers"
        :items="[schoolBankAccount]"
        disable-sort
        hide-default-footer
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn text icon @click="openDialog(item)">
            <v-icon dense>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <PopupAccount ref="popup-account" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PopupAccount from './PopupAccount.vue'
export default {
  components: {
    PopupAccount,
  },
  props: {
    banks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'Ngân hàng', value: 'bankCode', align: 'left' },
        { text: 'Số tài khoản', value: 'accountNumber', align: 'left' },
        { text: 'Tên chủ tài khoản', value: 'accountName', align: 'left' },
        { text: 'Hành động', value: 'actions', align: 'center' },
      ],
    }
  },
  computed: {
    ...mapState({
      schoolBankAccount: (state) => state.schoolBankAccount.schoolBankAccount,
    }),
  },
  methods: {
    openDialog(item) {
      this.$refs['popup-account'].openDialog(item, this.banks)
    },
  },
}
</script>

<style></style>
